import { Link } from 'react-router-dom'
import { Calendar, Building, ArrowRight } from 'lucide-react'
import { getMediaUrl } from '../utils/media'

const CarteSeminaire = ({ seminaire }) => {
  return (
    <div className="bg-white rounded-xl overflow-hidden shadow-sm hover:shadow-xl transition-all border border-gray-100 flex flex-col h-full transform hover:-translate-y-1">
      <div className="relative h-48 overflow-hidden bg-gray-100">
        <img 
          src={getMediaUrl(seminaire.images && seminaire.images.length > 0 ? seminaire.images[0] : null, 'https://images.unsplash.com/photo-1542744173-8e7e53415bb0?q=80&w=800')} 
          alt={seminaire.titre}
          className="w-full h-full object-cover transition-transform duration-500 hover:scale-110"
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = 'https://images.unsplash.com/photo-1542744173-8e7e53415bb0?q=80&w=800';
          }}
        />
        <div className="absolute top-4 left-4">
          <span className="bg-cidh-gold text-white text-[10px] font-bold px-2 py-1 rounded uppercase tracking-tighter shadow-sm">
            SÉMINAIRE
          </span>
        </div>
      </div>
      
      <div className="p-8 flex-grow flex flex-col">
        <h3 className="text-xl font-bold mb-3 text-cidh-blue line-clamp-2 leading-tight min-h-[3rem]">
          {seminaire.titre}
        </h3>
        
        <div className="mt-auto space-y-3 mb-8">
          <div className="flex items-center gap-3 text-sm text-gray-500">
            <Calendar size={16} className="text-cidh-gold shrink-0" />
            <span className="font-medium">Date: {seminaire.date_texte}</span>
          </div>
          <div className="flex items-center gap-3 text-sm text-gray-500">
            <Building size={16} className="text-cidh-gold shrink-0" />
            <span className="font-medium">Client: {seminaire.entreprise}</span>
          </div>
        </div>
        
        <Link 
          to={`/seminaires/${seminaire.id}`} 
          className="w-full text-center py-3 bg-cidh-blue text-white font-bold rounded-xl hover:bg-opacity-90 transition-all shadow-md hover:shadow-lg flex items-center justify-center gap-2"
        >
          Détails du séminaire <ArrowRight size={18} />
        </Link>
      </div>
    </div>
  )
}

export default CarteSeminaire
